module.exports = __webpack_public_path__ + "img/3.ec561f15.jpg";